import { useCallback, useState } from 'react';

export const useCalendarNavigation = (initMonth: number, initYear: number) => {
    const [month, setMonth] = useState(initMonth);
    const [year, setYear] = useState(initYear);

    const navigateMonth = useCallback(
        (direction: 'prev' | 'next') => {
            const today = new Date();
            const bounds = {
                min: new Date(today.getFullYear() - 1, today.getMonth()),
                max: new Date(today.getFullYear() + 1, 11, 31),
            };

            const newDate = new Date(year, month - 1 + (direction === 'next' ? 1 : -1));

            if (newDate >= bounds.min && newDate <= bounds.max) {
                setMonth(newDate.getMonth() + 1);
                setYear(newDate.getFullYear());
            }
        },
        [month, year]
    );

    return {
        month,
        year,
        navigateMonth,
        prevMonth: () => navigateMonth('prev'),
        nextMonth: () => navigateMonth('next'),
    };
};
